module.exports = __webpack_public_path__ + "static/media/warningblue.655fff2f.svg";